import { useState } from "react";
var MARKETS = [
    {
        country: {
            name: "Deutschland",
            code: "DE"
        },
        language: {
            name: "Deutsch",
            code: "de"
        },
        redirectInfo: {
            text: "Wir k\xf6nnen Sie auf unseren deutschen Marktf\xfchrer billiger-mietwagen.de weiterleiten, damit Sie Ihr bestes Angebot finden.",
            header: "Weiterleiten",
            link: {
                text: "Zu billiger-mietwagen.de",
                url: "https://www.billiger-mietwagen.de"
            }
        }
    },
    {
        country: {
            name: "Frankreich",
            code: "FR"
        },
        language: {
            name: "Franz\xf6sisch",
            code: "fr"
        },
        redirectInfo: {
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            header: "Weiterleiten",
            link: {
                text: "Zu carigami.fr",
                url: "https://www.carigami.fr"
            }
        }
    },
    {
        country: {
            name: "Spanien",
            code: "ES"
        },
        language: {
            name: "Spanisch",
            code: "es"
        }
    },
    {
        country: {
            name: "Niederlande",
            code: "NL"
        },
        language: {
            name: "Niederl\xe4ndisch",
            code: "nl"
        }
    },
    {
        country: {
            name: "Italien",
            code: "IT"
        },
        language: {
            name: "Italienisch",
            code: "it"
        }
    }, 
];
var useMockedMarketPicker = function() {
    // Use mock data in storybook / testing
    var ref = useState(MARKETS[0]), selectedMarket = ref[0], setMarket = ref[1];
    return {
        selectedMarket: selectedMarket,
        selectMarket: setMarket,
        markets: MARKETS
    };
};
export { MARKETS, useMockedMarketPicker };
